export default __webpack_public_path__ + "static/media/sales.91d07d5c.svg";